/**
 * The composer's "…" menu ("Reading options"): the reading's own actions
 * (Finish, Share, Pull a card, Exit) plus the Mystic's quick actions. It never
 * repeats what the chips on screen already offer (Chris's hand test
 * 2026-10-26 #3: the own reading's three starters were listed twice, once as
 * chips and again in the menu). Pure, so it is testable.
 */

const keyOf = (a) => `${String((a && a.action_type) || '')}|${String((a && a.button_label) || '').trim().toLowerCase()}`

/** `actions` without any the chips (`chips`) already show. */
export function menuWithoutChips (actions, chips) {
  const list = Array.isArray(actions) ? actions.filter(Boolean) : []
  const shown = new Set((Array.isArray(chips) ? chips : []).filter(Boolean).map(keyOf))
  if (!shown.size) return list
  return list.filter((a) => !shown.has(keyOf(a)))
}
